module.exports = __webpack_public_path__ + "img/3.4d17c6be.jpg";